import { baseApi } from 'services/api';
import { API_VERSION } from 'constants/common';
import { setCapitalFinancingEnabled } from './capitalSlice';

export const capitalApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    createCapitalSessionToken: builder.mutation({
      query: ({ teamId }) => ({
        url: `/${API_VERSION.V1}/team/${teamId}/connect/capital-financing-session/initialize`,
        method: 'GET'
      }),
      extraOptions: {
        failure: 'Failed to initialize Capital financing',
        showToast: true
      }
    }),

    checkCapitalFinancingEnabled: builder.query({
      query: ({ teamId }) => ({
        url: `/${API_VERSION.V1}/team/${teamId}/connect/capital-financing/enabled-check`,
        method: 'GET'
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(setCapitalFinancingEnabled(data.hasCapitalFinancingEnabled || false));
        } catch (error) {
          dispatch(setCapitalFinancingEnabled(false));
        }
      }
    })
  })
});

export const {
  useCreateCapitalSessionTokenMutation,
  useCheckCapitalFinancingEnabledQuery,
  useLazyCheckCapitalFinancingEnabledQuery
} = capitalApi;
